import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from '../../../core/view/view.component';
import { FamiliesService } from '../families.service';

@Component({
  selector: 'app-families-detail',
  templateUrl: './families-detail.component.html',
  styleUrls: ['./families-detail.component.scss']
})
export class FamiliesDetailComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public family: any = {};
  constructor(
    private familiesService: FamiliesService,

    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private coreDialogService: CoreDialogService,
  ) { }

  ngOnInit(): void {
    this.loadFamilies(this.config.data.id);
  }

  loadFamilies(id) {
    if (id) {
      this.familiesService.get(id).subscribe(
        data => {
          this.family = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  save(event: any) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    if (typeof this.family.id === "undefined") {
      this.familiesService.add(this.family).subscribe(
        data => {
          this.dynamicDialogRef.close();
          this.messageService.add({ closable: false, severity: 'success', summary: "Familia añadida correctamente." });
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    } else {
      this.familiesService.save(this.family.id, this.family).subscribe(
        data => {
          this.familiesService.add({ closable: false, severity: "success", detail: "Familia guardada correctamente" });
          this.dynamicDialogRef.close();
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      )
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  delete() {
    this.coreDialogService.confirm({
      message: "¿Quieres borrar la familia " + this.family.name + "?",
      header: "Confirmación de borrado",
      icon: "pi pi-info-circle",
      accept: () => {
        this.familiesService.delete(this.family.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: 'success', detail: "Borrada correctamente" });
            this.dynamicDialogRef.close();
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        )
      },
      reject: () => {

      }
    })
  }

  isDuplied(family, event) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: "Datos incompletos. Por favor, revisa el formulario." });
      return;
    }
    this.familiesService.isDuplied(family).subscribe(
      data =>{
        if(data==true){
          this.coreDialogService.notify({
            message:"Ya existe una familia con estos datos proporcionados.",
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept:() => { }
          });
        }else{
          this.save(event);
        }
      }
    );
  }

  onEvent(event) {
    if (event.component == "families.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.isDuplied(this.family,event);
    }
    if (event.component == "view" && event.event == "entity-loaded") {
      this.config.header = typeof (this.family.id) !== "undefined" ? "Detalles de la " + this.view.getEntityBaseName() : "Nueva " + this.view.getEntityBaseName();
    }
  }
}
